<template>
  <FormCard v-if="role" :config="general_data" @DataSaved="UpdateData" />
</template>
<script>
import FormCard from "../../../common/form/CardNew";
import GetOptionsPure from "../../../common/form/optionsPure";

export default {
  data() {
    return {
      languages: {
        de: "Deutsch",
        en: "English",
        it: "Italiano",
        fr: "Français",
      },
    };
  },
  model: {
    prop: "role",
    event: "change",
  },
  props: ["role"],
  components: {
    FormCard,
  },
  methods: {
    UpdateData(data) {
      this.$emit("change", data);
    },
  },
  computed: {
    languageOptions() {
      let options = [];
      const langKeys = Object.keys(this.$i18n.messages);
      langKeys.forEach((key) => {
        options.push({
          value: key,
          label: this.languages[key],
        });
      });
      return options;
    },

    general_data() {
      return {
        title: this.$t("role.role.tab_info.card_general.title"),
        data: this.role,
        fields: {
          name: {
            title: this.$t("models.role.name"),
            description: this.$t("models.role.name_info"),
            type: "CInput",
            size: 12,
            subsize: [2, 10],
          },
          "family.f_type": {
            title: this.$t("models.family.f_type"),
            type: "CInputRadioGroup",
            size: 12,
            subsize: [2, 10],
            options: [
              {
                value: "1",
                label: this.$t("models.family.f_type_option1_info"),
              },
              {
                value: "2",
                label: this.$t("models.family.f_type_option2_info"),
              },
              {
                value: "3",
                label: this.$t("models.family.f_type_option3_info"),
              },
            ],
            description: this.$t("models.family.f_type_info"),
          },
          "family.name": {
            title: this.$t("models.family.name"),
            description: this.$t("models.family.name_info"),
            type: "CInput",
            size: 12,
            subsize: [2, 10],
            enabled: this.role.family.f_type != "1",
          },
          tax_exempt: {
            title: this.$t("models.role.tax_exempt"),
            description: this.$t("models.role.tax_exempt_info"),
            type: "CInputRadioGroup",
            size: 12,
            subsize: [2, 10],
            options: [
              { value: true, label: this.$t("common.bool.false") },
              { value: false, label: this.$t("common.bool.true") },
            ],
            enabled: this.role.family.f_type != "1",
          },
          tax_number: {
            title: this.$t("models.role.tax_number"),
            description: this.$t("models.role.tax_number_info"),
            type: "CInput",
            size: 12,
            subsize: [2, 10],
            enabled:
              this.role.family.f_type != "1" && this.role.tax_exempt == false,
          },
          tel: {
            title: this.$t("models.role.phone"),
            description: this.$t("models.role.phone_info"),
            type: "CInput",
            size: 12,
            subsize: [2, 10],
          },
          email: {
            title: this.$t("models.email.email"),
            type: "CInput",
            size: 12,
            subsize: [2, 10],
          },
          url: {
            title: this.$t("models.role.web"),
            description: this.$t("models.role.web_info"),
            type: "CInput",
            size: 12,
            subsize: [2, 10],
          },
          country_id: {
            title: this.$t("models.role.country"),
            description: this.$t("models.role.country_info"),
            type: "CSelect",
            size: 12,
            subsize: [2, 10],
            options: GetOptionsPure({
              api: "geo_country",
              reducer: function (map, obj) {
                map.push({ value: obj.code, label: obj.name });
                return map;
              },
              reducer_cache: "geo_country",
            }),
          },
          "family.doc_lang": {
            title: this.$t("models.role.docLang"),
            description: this.$t("models.role.docLang_info"),
            type: "CSelect",
            size: 12,
            subsize: [2, 10],
            options: this.languageOptions,
          },
        },
        endpoint: "auth_frole",
      };
    },
  },
};
</script>
